import { Serializable } from "../utilities/Serializable";
import { CouponType } from "./CouponType";

export class Coupon extends Serializable {
    uuid: string;
    type: CouponType;
    date: number;
    amount: number;
    initialAmount: number;
    cardUuid: string;
    posUuid: string;
    constructor() {
        super();
        this.amount = 0;
        this.initialAmount = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Coupon.ts